module.exports = __webpack_public_path__ + "static/media/venues.78d700ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/venues.svg
// module id = 84
// module chunks = 1